import { render, staticRenderFns } from "./EditProjectPartner.vue?vue&type=template&id=aafc77b0&"
import script from "./EditProjectPartner.vue?vue&type=script&lang=js&"
export * from "./EditProjectPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports